import { ISVGChartWidget } from '@/pages/Dashboards/dashboards.types.ts'
import { ISVGSettings } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import { useEffect } from 'react'
import SeparateLine from '@/shared/Forms/SeparateLine'
import SVGChartSettingsContent from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/SVGChartSettingsContent'

interface IProps {
  onChange: (val: ISVGSettings) => void
  widget: ISVGChartWidget
}

const UpdateSvgChartWidgetContent = (props: IProps) => {
  const [settings, setSettings] = useStateWithChange(props.widget.configuration.settings)

  useEffect(() => {
    props.onChange(settings)
  }, [settings, props.onChange])

  return (
    <div className="flex-lines gap16 height100" style={{ minHeight: 0 }}>
      <h5 className="text-heading-5">Редактирование виджета: SVG диаграмма</h5>
      <SeparateLine />
      <SVGChartSettingsContent setSettings={setSettings} step="settings" settings={settings} />
    </div>
  )
}

export default UpdateSvgChartWidgetContent
